var Quagga = require('quagga')
angular.module('common.directives').directive('quaggaBarcode', [
  '$timeout',
  '$interval',
  function ($timeout, $interval) {
    function linkFunction ($scope, element, attrs) {
      var currentBrowser = getBrowserInfo().name

      var vm = this
      Quagga.onDetected(_onDetected)
      Quagga.onProcessed(_onProcessed)
      function _onProcessed (result) {
        var drawingCtx = Quagga.canvas.ctx.overlay

        var drawingCanvas = Quagga.canvas.dom.overlay

        if (result) {
          if (result.boxes) {
            drawingCtx.clearRect(
              0,
              0,
              parseInt(drawingCanvas.getAttribute('width')),
              parseInt(drawingCanvas.getAttribute('height'))
            )
            result.boxes
              .filter(function (box) {
                return box !== result.box
              })
              .forEach(function (box) {
                Quagga.ImageDebug.drawPath(box, { x: 0, y: 1 }, drawingCtx, {
                  color: 'green',
                  lineWidth: 2
                })
              })
          }

          if (result.box) {
            Quagga.ImageDebug.drawPath(result.box, { x: 0, y: 1 }, drawingCtx, {
              color: '#00F',
              lineWidth: 2
            })
          }

          if (result.codeResult && result.codeResult.code) {
            Quagga.ImageDebug.drawPath(
              result.line,
              { x: 'x', y: 'y' },
              drawingCtx,
              { color: 'red', lineWidth: 3 }
            )
          }
        }
      }
      function _onDetected (result) {
        if ($scope.onDetected) {
          $scope.onDetected({ result: result })
        }
      }
      $scope.started = false
      $scope.selectedCameraId = undefined
      $scope.startQuagga = function () {
        var usingCamId = undefined
        if ($scope.selectedCameraId) {
          usingCamId = $scope.selectedCameraId
        }

        var quagga_config = {
          numOfWorkers: 8,
          frequency: 10,
          locate: false,
          inputStream: {
            name: 'Live',
            type: 'LiveStream',
            constraints: {
              width: 800,
              height: 600,
              aspectRatio: 21 / 9,
              deviceId: usingCamId
            }
          },
          decoder: {
            readers: [$scope.type() + '_reader'],
            patchSize: 'large',
            debug: {
              drawBoundingBox: true,
              showFrequency: true,
              drawScanline: true,
              showPattern: true
            }
          }
        }
        if (currentBrowser == 'Safari') {
          quagga_config = {
            locate: false,
            inputStream: {
              name: 'Live',
              type: 'LiveStream'
            },
            decoder: {
              readers: [$scope.type() + '_reader']
            }
          }
        }
        Quagga.init(quagga_config, function (err) {
          if (err) {
            return
          }

          Quagga.start()
        })
        $scope.started = true
      }
      $scope.StopQuagga = function () {
        if ($scope.started) {
          Quagga.stop()
        }
        $scope.started = false
      }
      $scope.quaggaCameraFullscreen_enter = function () {
        var elem = document.querySelector('#interactive video')

        if (elem.webkitRequestFullScreen != undefined) {
          elem.webkitRequestFullScreen()
        } else if (elem.mozRequestFullScreen != undefined) {
          elem.mozRequestFullScreen()
        }
        if (elem.webkitEnterFullScreen != undefined) {
          elem.webkitEnterFullScreen()
        }
      }
      $scope.quaggaCameraFullscreen_exit = function () {
        if (document.exitFullscreen) {
          document.exitFullscreen()
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      }
      $scope.fullScreenHunter = $interval(function () {
        var fullscreenState =
          document.fullScreen ||
          document.mozFullScreen ||
          document.webkitIsFullScreen ||
          document.webkitFullscreenElement
        if (fullscreenState) {
          $scope.fullScreenTracker(true)
        } else {
          $scope.fullScreenTracker(false)
        }
      }, 2000)
      $scope.$watch($scope.scanStatus, function (value) {
        if (value) {
          $scope.startQuagga()
        } else {
          $scope.StopQuagga()
        }
      })
      $scope.$watch($scope.fullScreen, function (value) {
        if (value) {
          $scope.quaggaCameraFullscreen_enter()
        } else {
          $scope.quaggaCameraFullscreen_exit()
        }
      })
      $scope.$watch($scope.cameraId, function (value) {
        $scope.selectedCameraId = value
        if (value) {
          $scope.StopQuagga()
          $timeout(function () {
            $scope.startQuagga()
          }, 200)
        }
      })

      $scope.$on('destroy', function () {
        Quagga.offProcessed(_onProcessed)
        Quagga.offDetected(_onDetected)
        $interval.cancel($scope.fullScreenHunter)
      })
      function getBrowserInfo () {
        var ua = navigator.userAgent

        var tem

        var M =
          ua.match(
            /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
          ) || []
        var NameBrowser = undefined
        var VersionBrowser = undefined

        if (/trident/i.test(M[1])) {
          tem = /\brv[ :]+(\d+)/g.exec(ua) || []
          NameBrowser = 'IE'
          VersionBrowser = tem[1] || ''
        }

        if (M[1] === 'Chrome') {
          tem = ua.match(/\bOPR|Edge\/(\d+)/)

          if (tem == null) {
            NameBrowser = M[1]
            VersionBrowser = M[2]
          } else {
            if (tem[0].indexOf('Edge') > -1) {
              NameBrowser = 'Edge'
              VersionBrowser = tem[1]
            } else {
              NameBrowser = tem[0]

              if (tem[1] != undefined) VersionBrowser = tem[1]
              else {
                if (NameBrowser == 'OPR') {
                  VersionBrowser = tem.input.substring(
                    tem.input.indexOf('OPR/') + 4
                  )
                }
              }
            }
          }
        } else {
          M = M[2]
            ? [M[1], M[2]]
            : [navigator.appName, navigator.appVersion, '-?']
          if ((tem = ua.match(/version\/(\d+)/i)) != null) {
            M.splice(1, 1, tem[1])
          }
          NameBrowser = M[0]
          VersionBrowser = M[1]
        }

        var firstBracket = ua.indexOf('(')
        var secondBracket = ua.indexOf(')')
        var NameOS = ua.substring(firstBracket + 1, secondBracket)
        return {
          name: NameBrowser,
          version: VersionBrowser,
          os: NameOS
        }
      }
    }
    return {
      restrict: 'E',
      scope: {
        type: '&',
        onDetected: '&',
        scanStatus: '&',
        cameraId: '&',
        fullScreen: '&',
        fullScreenTracker: '&'
      },
      template: '<div id="interactive" class="viewport"></div>',
      link: linkFunction
    }
  }
])
